var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.511,
    height: 15.492,
    viewBox: "0 0 21.511 21.492",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Edit",
    d: "M126.821,248.066l-2.019-2.019a2.193,2.193,0,0,0-3.03,0l-2.019,2.019h0l-12.311,12.311a2.2,2.2,0,0,0-.21.245.621.621,0,0,0-.1.067.708.708,0,0,0-.206.525,2.244,2.244,0,0,0-.075.276l-.9,4.591a.715.715,0,0,0,.7.852.742.742,0,0,0,.138-.014l4.591-.9a2.113,2.113,0,0,0,.276-.076c.006,0,.013,0,.02,0a.714.714,0,0,0,.5-.209.667.667,0,0,0,.067-.1,2.135,2.135,0,0,0,.245-.211L124.3,253.62l2.525-2.524A2.144,2.144,0,0,0,126.821,248.066Zm-18.743,14.581,2.144,2.143-2.665.523Zm3.6,1.577-3.03-3.03,11.612-11.612h0l.8.8-9.088,9.088a.714.714,0,1,0,1.01,1.01l9.088-9.088,1.219,1.219Zm14.137-14.137L124.3,251.6l-1.723-1.724h0l-1.305-1.3,1.515-1.515a.73.73,0,0,1,1.009,0l2.019,2.019A.715.715,0,0,1,125.811,250.086Z",
    transform: "translate(-105.936 -245.439)",
    fill: "#606060"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.0c77cbd4cfba21f98de9f4f27949080e.svg";
export { ForwardRef as ReactComponent };